import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function OwnerNotifications() {
  const [showNewOrderDialog, setShowNewOrderDialog] = useState(false);
  const [knownOrderIds, setKnownOrderIds] = useState(new Set());
  const [audioEnabled, setAudioEnabled] = useState(true);
  const isFirstLoadRef = useRef(true);

  useEffect(() => {
    // Initial fetch
    fetchOrders();
    
    // Poll for new orders every 5 seconds (more responsive)
    const interval = setInterval(fetchOrders, 5000);
    
    return () => clearInterval(interval);
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/owner/orders`);
      const newOrders = response.data;
      
      // Get current order IDs
      const currentOrderIds = new Set(newOrders.map(order => order.id));
      
      // Check if there are NEW orders (not just count change)
      // Skip first load to initialize the known IDs
      if (!isFirstLoadRef.current && knownOrderIds.size > 0) {
        // Find orders that are new (in current but not in known)
        const newOrdersList = newOrders.filter(order => !knownOrderIds.has(order.id));
        const hasNewOrders = newOrdersList.length > 0;
        
        if (hasNewOrders) {
          console.log('🔔 Nuovo ordine rilevato!');
          console.log('Ordini noti:', Array.from(knownOrderIds));
          console.log('Ordini correnti:', newOrders.map(o => o.id));
          console.log('Nuovi ordini:', newOrdersList.map(o => o.order_number || o.id));
          
          setShowNewOrderDialog(true);
          
          // Show toast notification as well
          // toast.success(`Nuovo ordine ricevuto! (${newOrdersList.length})`);
          
          
          // Try to play sound and vibrate
          try {
            // Vibration for mobile/Safari
            if ('vibrate' in navigator) {
              navigator.vibrate([200, 100, 200, 100, 200]);
            }
            
            // Audio - only if enabled
            if (audioEnabled) {
              const audioContext = new (window.AudioContext || window.webkitAudioContext)();
              
              // Simple bell sound
              const playBeep = (frequency, delay) => {
                setTimeout(() => {
                  const oscillator = audioContext.createOscillator();
                  const gainNode = audioContext.createGain();
                  
                  oscillator.connect(gainNode);
                  gainNode.connect(audioContext.destination);
                  
                  oscillator.frequency.value = frequency;
                  gainNode.gain.value = 0.3;
                  
                  oscillator.start(audioContext.currentTime);
                  gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
                  oscillator.stop(audioContext.currentTime + 0.3);
                }, delay);
              };
              
              // Play 3 beeps
              playBeep(800, 0);
              playBeep(1000, 300);
              playBeep(1200, 600);
            }
            
          } catch (error) {
            console.log('Audio/vibrazione non disponibile:', error);
          }
        }
      }
      
      // Update known order IDs
      setKnownOrderIds(currentOrderIds);
      isFirstLoadRef.current = false;
      
    } catch (error) {
      console.error('Errore controllo nuovi ordini:', error);
    }
  };

  return (
    <Dialog open={showNewOrderDialog} onOpenChange={setShowNewOrderDialog}>
      <DialogContent className="bg-orange-600 border-orange-500 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold text-center text-white">
            🔔 Hai ricevuto un nuovo ordine!!!
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center py-6 space-y-4">
          <div className="text-6xl animate-bounce">
            📦
          </div>
          <Button
            onClick={() => {
              setShowNewOrderDialog(false);
              // Navigate to orders page if not already there
              if (window.location.pathname !== '/owner/orders') {
                window.location.href = '/owner/orders';
              }
            }}
            className="w-full bg-white text-orange-600 hover:bg-gray-100 font-bold py-4 text-lg"
          >
            OK, visualizza ordine
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
